import { Box, CircularProgress } from "@mui/material";
import { useLoadingStore } from "../../store/loadingStore";

export const CenterLoading = () => {
  const loading = useLoadingStore(({ loading }) => loading);
  if (!loading) return <></>;

  return (
    <Box
      sx={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress />
    </Box>
  );
};
